import React, { useState } from 'react';

import { X, Loader2 } from 'lucide-react';
import axios from 'axios';

import { Button } from './ui/button';
import { Input } from './ui/input';

const EbookPurchaseModal = ({ open, onClose }) => {
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [couponCode, setCouponCode] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  if (!open) return null;

  const startCheckout = async () => {
    setError('');
    if (!email.trim() || !email.includes('@')) {
      setError('Please enter a valid email.');
      return;
    }

    setIsLoading(true);
    try {
      // Testing-only free code (skips Stripe)
      if (couponCode.trim().toUpperCase() === 'HLFREE') {
        await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/payments/ebook/test-free`, {
          code: couponCode.trim(),
          email: email.trim(),
          first_name: firstName.trim() || null
        });

        onClose();
        window.location.href = '/resources?purchase=success';
        return;
      }

      const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/payments/ebook/checkout`, {
        email: email.trim(),
        first_name: firstName.trim() || null,
        origin_url: window.location.origin
      });

      window.location.href = res.data.url;
    } catch (e) {
      setError('Unable to start checkout. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/30" onClick={onClose} />
      <div className="relative w-full max-w-lg mx-4 bg-white rounded-2xl shadow-2xl border border-black/10 overflow-hidden">
        <div className="flex items-center justify-between px-6 py-4 border-b border-[#e8e6e1]">
          <div>
            <p className="text-xs tracking-widest uppercase text-[#243B29]/80">Recipe Ebook</p>
            <h3 className="text-lg font-semibold text-[#1e1919]">Checkout</h3>
          </div>
          <button
            onClick={onClose}
            className="p-2 rounded-full hover:bg-black/5 transition-colors"
            aria-label="Close"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="px-6 py-5">
          <p className="text-sm text-[#736c64] mb-4">
            Enter the email you want the download link sent to.
          </p>

          <div className="space-y-3">
            <div>
              <label className="block text-sm font-medium text-[#1e1919] mb-1">First name</label>
              <Input
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                placeholder="Your name"
                disabled={isLoading}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-[#1e1919] mb-1">Email</label>
              <Input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                disabled={isLoading}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-[#1e1919] mb-1">Coupon code</label>
              <Input
                value={couponCode}
                onChange={(e) => setCouponCode(e.target.value)}
                placeholder=""
                disabled={isLoading}
              />
              <p className="text-xs text-[#736c64] mt-1">For testing only.</p>
            </div>

            {error && <p className="text-sm text-red-600">{error}</p>}
          </div>
        </div>

        <div className="px-6 py-4 bg-[#f7f5f2] border-t border-[#e8e6e1] flex items-center justify-end gap-2">
          <Button variant="outline" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            onClick={startCheckout}
            disabled={isLoading}
            className="bg-[#a8b5a0] hover:bg-[#8fa087] text-white"
          >
            {isLoading ? (
              <>
                <Loader2 className="h-4 w-4 animate-spin" />
                Redirecting…
              </>
            ) : (
              'Continue to payment'
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EbookPurchaseModal;
